// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExperimentBar-module__dsAccented--hCA8I,.ExperimentBar-module__dsAccented--hCA8I *{font-weight:500}.ExperimentBar-module__dsDefaultWeight--osGnC,.ExperimentBar-module__dsDefaultWeight--osGnC *{font-weight:400}h5.ExperimentBar-module__dsAccented--hCA8I,h5.ExperimentBar-module__dsAccented--hCA8I *{font-weight:700}.ExperimentBar-module__dsUnderline--mMu9w,.ExperimentBar-module__dsUnderline--mMu9w *{text-decoration:underline}.ExperimentBar-module__dsAccented2--T9gKz,.ExperimentBar-module__dsAccented2--T9gKz *{font-weight:700}.ExperimentBar-module__dsBodyXL--phH5x,.ExperimentBar-module__dsBodyXL--phH5x *{font-size:18px;line-height:27px}.ExperimentBar-module__dsBodyLarge--vFHrz,.ExperimentBar-module__dsBodyLarge--vFHrz *{font-size:16px;line-height:24px}.ExperimentBar-module__dsBody--bA1RP,.ExperimentBar-module__dsBody--bA1RP *{font-size:14px;line-height:20px}.ExperimentBar-module__dsBodySmall--NYLRJ,.ExperimentBar-module__dsBodySmall--NYLRJ *{font-size:12px;line-height:18px}.ExperimentBar-module__dsBodyXS--t0bW6,.ExperimentBar-module__dsBodyXS--t0bW6 *{font-size:10px;line-height:15px}.ExperimentBar-module__dsActionLarge--fOqr9,.ExperimentBar-module__dsActionLarge--fOqr9 *{font-size:16px;line-height:18px}.ExperimentBar-module__dsAction--kTBgU,.ExperimentBar-module__dsAction--kTBgU *{font-size:14px;line-height:16px}.ExperimentBar-module__dsActionSmall--fSCjT,.ExperimentBar-module__dsActionSmall--fSCjT *{font-size:12px;line-height:14px}.ExperimentBar-module__dsColumnHeadLine--Vgocd,.ExperimentBar-module__dsColumnHeadLine--Vgocd *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.ExperimentBar-module__dsLightXL--siRzU,.ExperimentBar-module__dsLightXL--siRzU *{font-size:120px;line-height:160px;font-weight:300}.ExperimentBar-module__dsLightLarge--bCePq,.ExperimentBar-module__dsLightLarge--bCePq *{font-size:48px;line-height:64px;font-weight:300}.ExperimentBar-module__dsLight--gadie,.ExperimentBar-module__dsLight--gadie *{font-size:32px;line-height:64px;font-weight:300}.ExperimentBar-module__dsLightSmall--S3Daf,.ExperimentBar-module__dsLightSmall--S3Daf *{font-size:24px;line-height:36px;font-weight:300}.ExperimentBar-module__dsLightXS--DTo6_,.ExperimentBar-module__dsLightXS--DTo6_ *{font-size:18px;line-height:27px;font-weight:300}:root{--experiment-select-width: 200px}.ExperimentBar-module__container--LDQAc{display:flex;padding:24px;align-items:center}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__wrapContainer--UCkq4{display:flex;gap:20px;flex-wrap:wrap;align-items:flex-end}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp{display:flex;flex-direction:column;justify-content:flex-end}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__search--aRCEC{width:200px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__custom--lgMaO{width:160px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__custom--lgMaO .ExperimentBar-module__componentWrapper--shrrr{display:flex;align-items:center;min-height:36px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__custom--lgMaO .ds-slider-container{padding-bottom:2px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__stepSlider--pj7ex .ExperimentBar-module__componentWrapper--shrrr{display:flex;align-items:flex-end;min-height:36px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5{width:var(--experiment-select-width)}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo{width:180px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr{display:flex;gap:4px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr>div{width:140px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd{width:36px;height:36px;padding:8px 0;border:1px solid #dce0ea;border-radius:5px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd.ExperimentBar-module__asc--u8HB4 svg{transform:rotate(180deg)}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd.ExperimentBar-module__disabled--n1HKu{background:#f5f7fa}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd.ExperimentBar-module__disabled--n1HKu svg{color:#b3b9c8}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd:hover{border-color:#b3b9c8}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp.ExperimentBar-module__select--g0fd5.ExperimentBar-module__sort--mHKXo .ExperimentBar-module__componentWrapper--shrrr .ExperimentBar-module__button--I1DZd:hover svg{color:#5155f5;fill:#5155f5}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__component--vNcQp .ExperimentBar-module__title--QXQdV{color:#5f677e;font-size:14px;line-height:20px;font-weight:500;margin-bottom:6px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__spacer--UIeiz{display:flex;flex:1 1 auto;min-width:22px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__rightContainer--zuQqm{align-self:flex-end}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__toggleContainer--YatJL{display:flex;align-items:center;gap:10px;height:38px}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__toggleLabel--rP47u{display:flex;align-items:center;font-size:14px;color:#5f677e}.ExperimentBar-module__container--LDQAc .ExperimentBar-module__actionList--DZiXg{display:flex;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `ExperimentBar-module__dsAccented--hCA8I`,
	"dsDefaultWeight": `ExperimentBar-module__dsDefaultWeight--osGnC`,
	"dsUnderline": `ExperimentBar-module__dsUnderline--mMu9w`,
	"dsAccented2": `ExperimentBar-module__dsAccented2--T9gKz`,
	"dsBodyXL": `ExperimentBar-module__dsBodyXL--phH5x`,
	"dsBodyLarge": `ExperimentBar-module__dsBodyLarge--vFHrz`,
	"dsBody": `ExperimentBar-module__dsBody--bA1RP`,
	"dsBodySmall": `ExperimentBar-module__dsBodySmall--NYLRJ`,
	"dsBodyXS": `ExperimentBar-module__dsBodyXS--t0bW6`,
	"dsActionLarge": `ExperimentBar-module__dsActionLarge--fOqr9`,
	"dsAction": `ExperimentBar-module__dsAction--kTBgU`,
	"dsActionSmall": `ExperimentBar-module__dsActionSmall--fSCjT`,
	"dsColumnHeadLine": `ExperimentBar-module__dsColumnHeadLine--Vgocd`,
	"dsLightXL": `ExperimentBar-module__dsLightXL--siRzU`,
	"dsLightLarge": `ExperimentBar-module__dsLightLarge--bCePq`,
	"dsLight": `ExperimentBar-module__dsLight--gadie`,
	"dsLightSmall": `ExperimentBar-module__dsLightSmall--S3Daf`,
	"dsLightXS": `ExperimentBar-module__dsLightXS--DTo6_`,
	"container": `ExperimentBar-module__container--LDQAc`,
	"wrapContainer": `ExperimentBar-module__wrapContainer--UCkq4`,
	"component": `ExperimentBar-module__component--vNcQp`,
	"search": `ExperimentBar-module__search--aRCEC`,
	"custom": `ExperimentBar-module__custom--lgMaO`,
	"componentWrapper": `ExperimentBar-module__componentWrapper--shrrr`,
	"stepSlider": `ExperimentBar-module__stepSlider--pj7ex`,
	"select": `ExperimentBar-module__select--g0fd5`,
	"sort": `ExperimentBar-module__sort--mHKXo`,
	"button": `ExperimentBar-module__button--I1DZd`,
	"asc": `ExperimentBar-module__asc--u8HB4`,
	"disabled": `ExperimentBar-module__disabled--n1HKu`,
	"title": `ExperimentBar-module__title--QXQdV`,
	"spacer": `ExperimentBar-module__spacer--UIeiz`,
	"rightContainer": `ExperimentBar-module__rightContainer--zuQqm`,
	"toggleContainer": `ExperimentBar-module__toggleContainer--YatJL`,
	"toggleLabel": `ExperimentBar-module__toggleLabel--rP47u`,
	"actionList": `ExperimentBar-module__actionList--DZiXg`
};
module.exports = ___CSS_LOADER_EXPORT___;
